import ROUTES from "../../consts/routes";
import featureFlags from "../../consts/featureFlags";

export const SidebarData = [
  {
    title: "THE SAVANT HOME",
    path: "",
    links: [
      {
        title: "Introducing Smart Living",
        path: "/what-is-savant",
      },
      {
        title: "Living with Savant",
        path: "/savant-timeline",
      },
      {
        title: "Savant App",
        path: "/savant-pro-app",
      },
    ],
  },
  ...(featureFlags.caseStudiesMenuItem
    ? [
        {
          title: "CASE STUDIES",
          path: ROUTES.CASE_STUDIES,
          links: [],
        },
      ]
    : []),
  {
    title: "OUR PRODUCTS",
    path: "",
    links: [
      {
        title: "Whole Home Audio",
        path: "/whole-home-audio",
      },
      {
        title: "Home Theater",
        path: "/home-theater",
      },
      {
        title: "Speakers",
        path: "/artisonspeakers",
      },
      {
        title: "Smart Lighting",
        path: "/lighting",
      },
      {
        title: "Motorized Shades",
        path: "/shades",
      },
      {
        title: "Climate Control",
        path: "/climate",
      },
      {
        title: "Pro Remote",
        path: "/pro-remote-x2",
      },
      {
        title: "User Experiences",
        path: "/interfaces",
      },
      {
        title: "Hosts & Controllers",
        path: "/host",
      },
      {
        title: "Door Entry & Security",
        path: "/entry-services",
      },
    ],
  },
  {
    title: "SAVANT POWER SYSTEM",
    path: "/power",
    links: [],
    //iconType: "SavantPower",
    //width: "180px",
  },
  {
    title: "GE LIGHTING",
    path: "https://www.gelighting.com/",
    links: [],
  },
  {
    title: "FIND A DEALER",
    path: "/find-a-dealer",
    links: [],
  },
  {
    title: "ONLINE PRODUCT CATALOG",
    path: "https://store.savant.com/DefaultStore/ccrz__HomePage",
    target: "_blank",
    links: [],
  },
  {
    title: "RESOURCES",
    path: "",
    links: [
      {
        title: "Support & Specifications",
        path: "/support",
        links: [],
      },
      ...(featureFlags.partnersMenuItem
        ? [
            {
              title: "Savant Partners",
              path: "/our-partners",
            },
          ]
        : []),
      {
        title: "Become A Dealer",
        path: "/become-a-dealer",
      },
      {
        title: "Brochures & Guides",
        path: "/brochures-and-guides",
      },
      {
        title: "Dealer Community",
        path: "https://community.savant.com/Customers",
        target: "_blank",
      },
    ],
  },
];

export const socialLinks = [
  {
    title: "Youtube",
    iconType: "Youtube",
    link: "https://www.youtube.com/user/SavantAV",
  },
  {
    title: "Facebook",
    iconType: "Facebook",
    link: "https://www.facebook.com/OfficialSavant",
  },
  {
    title: "Instagram",
    iconType: "Instagram",
    link: "https://www.instagram.com/savantsystems",
  },
  {
    title: "Twitter",
    iconType: "Twitter",
    link: "https://twitter.com/savanthome/",
  },
];
